import styled from 'styled-components'

type WrapperProps = {
  $project: 'fepo' | 'training'
}
export const Wrapper = styled.div<WrapperProps>`
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;

  @media (max-width: 670px) {
    display: ${({ $project }) => $project === 'training' ? 'block' : 'flex'};
  }

  @media (max-width: 646px) {
    margin-bottom: 1rem;
  }

  @media (max-width: 400px) {
    display: block;
  }
`

export const Download = styled.div`
  @media (max-width: 1199px) {
    a {
      margin-bottom: 5px;
    }
  }
  @media (max-width: 400px) {
    margin-bottom: 5px;
  }
`

export const A = styled.a`
  @media (max-width: 537px) {
    margin-bottom: 5px;
  }
`
